export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '24px',
        padding: '16px',
        width: '100%',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '80px',
        padding: 2,
        gap: 2,
        flex: 1,
    },
    webhookInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        maxHeight: '40px',
        height: '40px',
    },
    logo: {
        width: '32px',
        height: '32px',
    },
    activeIcon: {
        color: 'rgb(86, 202, 0)',
    },
    inactiveIcon: {
        color: 'rgb(255, 76, 81)',
    },
    webhookValueContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        padding: '0 40px',
    },
    webhookValue: {
        textAlign: 'start',
        backgroundColor: '#f5f5f5',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        padding: '8px 12px',
        fontSize: '13px',
        color: '#333',
        fontFamily: 'inherit',
        lineHeight: '1.4',
        boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
        flex: '0 0 70%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    copyIcon: {
        color: '#3a3541de',
        cursor: 'pointer',
    },
    editIcon: {
        color: '#3a3541de',
        cursor: 'pointer',
    },
    deleteIcon: {
        color: '#3a3541de',
        cursor: 'pointer',
    },
    controlsContainer: {
        display: 'flex',
        alignItems: 'center',
        rowGap: 2,
        flex: '0 0 30%',
        justifyContent: 'flex-end',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    title: {
        fontSize: '14px',
        fontWeight: 'bold',
    },
};
